import getInitRooms from "./init/get-rooms";
import getInitGames from "./init/get-games";
import bookInitCalendar from "./init/calendar/calendar";
import getInitPlayers from "./init/get-players";
import initTimeSlot from "./init/get-time-slot";
import getInitDates from "./init/get-dates";
import sendInitForm from "./init/send-init-form";

export default class initBooking{

    private elForm: string = '#init-form-booking';
    private elBtn: string = '#btn-init-booking';
    private el_rooms: string = '#field-init-room';
    private el_games: string = '#field-init-game';
    private el_time_slot: string = '#field-init-time-slot';
    private el_players: string = '#field-init-players';

    // Calendar
    private modBookCalendar = bookInitCalendar('#field-init-book-calendar');

    // Rooms
    private modGetRooms = new getInitRooms();

    // Games
    private modGetGames = new getInitGames();

    // Players
    private modPlayers = new getInitPlayers();

    // Time slot
    private modTimeSlot = new initTimeSlot();

    // Dates
    private modGetDates = new getInitDates();

    init(){
        
        // Element form
        const form = document.querySelector(this.elForm) as HTMLFormElement | null;

        if(form === null){
            
            return null;

        }

        // Get players
        const get_players = this.modPlayers.getPlayers(this.el_players);

        // Get rooms
        this.modGetRooms.get(this.el_rooms);

        // Get games
        this.modGetGames.get(
            this.el_rooms,
            this.el_games,
            this.el_time_slot,
            this.modBookCalendar,
            get_players,
            this.modPlayers,
            this.modTimeSlot
        );

        // Get time slot
        this.modTimeSlot.get(
            this.modBookCalendar,
            this.el_rooms,
            this.el_games,
            this.el_time_slot
        );

        // Change date
        this.modGetDates.change(
            this.modBookCalendar,
            this.el_rooms,
            this.el_games,
            this.el_time_slot,
        );

        // Send form
        new sendInitForm(this.elForm, this.elBtn);

    }

}